import { Route as StockTakingRoute } from "@/routes/(pharma)/_layout/stock-taking/index";
import { useQuery } from "@tanstack/react-query";
import { getMedicalStock, getNonMedicalStock } from "../-data/api";
import type { 
  MedicalInventoryItem, 
  NonMedicalInventoryItem 
} from "@/gen/onboarding/common_pb";

interface StockTakingQueryResult {
  items: (MedicalInventoryItem | NonMedicalInventoryItem)[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const useStockTakingData = () => {
  const searchParams = StockTakingRoute.useSearch();
  
  const page = searchParams.page || 1;
  const pageSize = searchParams.pageSize || 10;
  
  return useQuery<StockTakingQueryResult>({
    queryKey: ["stock-taking", searchParams.type, searchParams.page, searchParams.pageSize, searchParams.search],
    queryFn: async () => {
      const search = searchParams.search || "";

      if (searchParams.type === 'MEDICAL') {
        const response = await getMedicalStock(page, pageSize, search);
        
        // Convert bigint to number for totalCount
        const totalCount = response.items.length > 0 
          ? Number(response.items[0].fullCount) 
          : 0;
        
        return {
          items: response.items,
          totalCount,
          page,
          pageSize
        };
      } else {
        const response = await getNonMedicalStock(page, pageSize, search);
        
        // Convert bigint to number for totalCount
        const totalCount = response.items.length > 0 
          ? Number(response.items[0].fullCount) 
          : 0;
        
        return {
          items: response.items,
          totalCount,
          page,
          pageSize
        };
      }
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};